import { UIIcon } from '../config/icons';
import { makeFriendCircle } from '../lib/ab/friends';
import { ABScreen } from '../lib/ab/screen';
import { aTrackPage } from '../lib/mdl/a-track';
import { MEFriendModel, meGetFriends, meHideFriend, meUnhideFriend } from '../lib/me/friends';
import { UIDataAdapter } from '../lib/ui/component/adapter';
import { UIList } from '../lib/ui/component/list';
import { $el } from '../lib/ui/elements';
import { UIView, UIViewSpec } from '../lib/ui/view';
import { HomeMenu } from './menu';

class FriendRow extends UIView {
    constructor(friend: MEFriendModel) {
        super('div', 'tl-friends-row');

        const block = $el.ICON(UIIcon.TRASH_CAN);
        this.ui_add([
            makeFriendCircle(friend.first_name, friend.last_name, friend.avatar),
            $el.SPAN('r-name',
                friend.first_name + ' ' + friend.last_name),
            $el.S(),
            block
        ]);

        block.addEventListener('click', () => {
            if(friend.hidden) {
                meUnhideFriend(friend.id);
            } else {
                meHideFriend(friend.id);
            }
        });
    }
}

export class HomeFriendsScreen extends ABScreen {
    constructor(_tab?: string) {
        super({ menu: new HomeMenu({ classes: 'm-account' }) });
    }

    protected override fillContent(content: UIViewSpec): void {
        const friends_maker = (f: MEFriendModel) => new FriendRow(f);

        const friends_adapter = new UIDataAdapter(friends_maker);
        const hidden_friends_adapter = new UIDataAdapter(friends_maker);

        const friends = new UIList(friends_adapter, { classes: 'l-v' });
        const hidden_friends = new UIList(hidden_friends_adapter, { classes: 'l-v' });

        meGetFriends(true).then(f => {
            const all = f.all;
            friends_adapter.data = all.filter(f => !f.hidden);
            hidden_friends_adapter.data = all.filter(f => f.hidden);
        });

        content.ui_add($el.DIV('ui-section', $el.DIV('w-block m-1200 l-form', [
            friends,
            $el.H3('heading', 'Hidden friends'),
            hidden_friends
        ])));

        aTrackPage('friends');
    }
}
